
import { Component, Vue, Emit, Inject, Watch } from "vue-property-decorator";
import { namespace } from "vuex-class";
import { vuex } from "@/store";
import rest from "@/rest";
import draggable from "vuedraggable";
// components
import SimpleMessageBox from "../Shared/SimpleMessageBox.vue";
import EditModulePageDlg from "./EditModulePageDlg.vue";
// interfaces
import { CcPageVm } from "@/interfaces/CcPageVm";

const globals = namespace("globals");

@Component({
  components: {
    draggable,
    EditModulePageDlg,
    SimpleMessageBox,
  }
})
export default class ModulePages extends Vue {
  @globals.Getter selectedBundle: any;
  @globals.Getter selectedExercise: any;
  @globals.Getter modulePages!: CcPageVm[];
  @globals.Getter selectedModulePage!: CcPageVm | null;
  @globals.Getter isMasterLanguageCode!: boolean;
  @globals.Action setModulePages!: (modulePages: CcPageVm[] | null) => Promise<void>;
  @globals.Action selectModulePage!: (number) => Promise<void>;
  // @globals.Action saveModulePages!: (boolean) => Promise<void>;
  @globals.Action addAndSelectModulePage!: () => Promise<void>;
  @globals.Action deleteModulePage!: (number) => Promise<void>;
  @globals.Action duplicateModulePage!: (number) => Promise<void>;

  showPageEditDlg = false;
  showConfirmDeletePage = false;
  pages: CcPageVm[] = []; // local array of module pages to be used by draggable component
  editPage: CcPageVm | null = null;
  pageToDelete: CcPageVm | null = null;

  async mounted() {
    this.updateView();
  }

  created() {
  }

  beforeDestroy() {
    // clearAllBodyScrollLocks();
  }

  @Watch("modulePages")
  onPagesChanged() {
    this.updateView();
  }

  async updateView() {
    // update local array of module pages to be used by draggable component
    if (this.modulePages && this.modulePages.length > 0) {
      this.pages = this.modulePages;
    } else {
      this.pages = [];
    }
  }

  onPageSelected(page: CcPageVm): void {
    this.selectModulePage(this.modulePages.indexOf(page));
  }

  onEditPage(page: CcPageVm): void {
    this.editPage = page;
    this.showPageEditDlg = true;
  }

  onConfirmDeletePages(page: CcPageVm) {
    this.pageToDelete = page;
    this.showConfirmDeletePage = true;
  }

  async onDeletePage(): Promise<void> {
    if (!this.pageToDelete) return;
    let index = this.modulePages.indexOf(this.pageToDelete);
    await this.deleteModulePage(index);
    this.showConfirmDeletePage = false;
  }

  async onDuplicatePages(page: CcPageVm) {
    let index = this.modulePages.indexOf(page);
    await this.duplicateModulePage(index);
  }

  async onDragEnd(): Promise<void> {
    // console.log("onDragEnd", this.pages);
    this.setModulePages(this.pages);
  }

  getPageBorderStyle(page: CcPageVm) {
    if (page == this.selectedModulePage)
      return `border: 2px solid ${this.$store.state.ux.colorAccent};`;
    return "";
  }
}
